import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { BrowserModule } from "@angular/platform-browser";
import { NoopAnimationsModule } from "@angular/platform-browser/animations";
import {
	AutoCompleteModule,
	CalendarModule,
	ChartModule,
	CheckboxModule,
	ConfirmationService,
	ConfirmDialogModule,
	DialogModule,
	DropdownModule,
	GrowlModule,
	InputMaskModule,
	InputTextareaModule,
	InputTextModule,
	ListboxModule,
	MultiSelectModule,
	OverlayPanelModule,
	TooltipModule,
	FileUploadModule,
} from "primeng/primeng";
import { UserOptionsComponent } from "./access-options/access-options.component";
import { ActivitiesComponent } from "./activities/activities.component";
import { AdministrationComponent } from "./administration/administration.component";
import { AnomalieComponent } from "./anomalie/anomalie.component";
import { AppComponent } from "./app.component";
import { routing } from "./app.routing";
import { AssenzeProspectComponent } from "./assenze-prospect/assenze-prospect.component";
import { AssenzeComponent } from "./assenze/assenze.component";
import { BusyComponent } from "./busy/busy.component";
import { UserCalendarComponent } from "./calendar-derogations-user/calendar-derogations-user.component";
import { CartellinoComponent } from "./cartellino/cartellino.component";
import { CheckhrDefsComponent } from "./checkhr-defs/checkhr-defs.component";
import { CheckhrUserComponent } from "./checkhr-user/checkhr-user.component";
import { CheckhrUsersComponent } from "./checkhr-users/checkhr-users.component";
import { CheckhrComponent } from "./checkhr/checkhr.component";
import { AuthAccessProvider } from "./core/core.auth";
import { ActivityDurationPipe, ClientsRequest, ClientsResponse, CoreComponent, DaysHoursPipe, OffersRequest, OffersResponse, PresenceDurationPipe, SafeHtmlPipe, ScadenzaRequest, ScadenzaResponse, StimeResponse } from "./core/core.component";
import { DailyActivityComponent } from "./daily-activity/daily-activity.component";
import { DailyPresenceComponent } from "./daily-presence/daily-presence.component";
import { DetailActivityComponent } from "./detail-activity/detail-activity.component";
import { DetailAssenzeComponent } from "./detail-assenze/detail-assenze.component";
import { DetailPresenceComponent } from "./detail-presence/detail-presence.component";
import { EquipmentDefsComponent } from "./equipment-defs/equipment-defs.component";
import { EquipmentUserComponent } from "./equipment-user/equipment-user.component";
import { EquipmentUsersComponent } from "./equipment-users/equipment-users.component";
import { EquipmentComponent } from "./equipment/equipment.component";
import { ExtraworkUserComponent } from "./extrawork-user/extrawork-user.component";
import { GlobalFilterComponent } from "./global-filter/global-filter.component";
import { HolidaysReportComponent } from "./holidays-report/holidays-report.component";
import { HomeComponent } from "./home/home.component";
import { LoginComponent } from "./login/login.component";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { PresencesComponent } from "./presences/presences.component";
import { ReportsComponent } from "./reports/reports.component";
import { AuthenticationService } from "./service/authentication.service";
import { BusyProvider } from "./service/busy.service";
import { MessageProvider } from "./service/message.service";
import { StatisticsComponent } from "./statistics/statistics.component";
import { TaskDetailComponent } from "./task-detail/task-detail.component";
import { TaskSelectorComponent } from "./task-selector/task-selector.component";
import { UserAnomaliesComponent } from "./user-anomalies/user-anomalies.component";
import { UserDataComponent } from "./userdata/userdata.component";
import { UsersProspectComponent } from "./users-prospect/users-prospect.component";
import { UsersComponent } from "./users/users.component";

import { UfficioComponent } from "./ufficio/ufficio.component";
import { ScrivanieComponent } from "./scrivanie/scrivanie.component";
import { DetailScrivaniaComponent } from "./scrivania-detail/scrivania-detail.component";
import { DetailSalaComponent } from "./sala-detail/sala-detail.component";
import { ElencoSalaComponent } from "./sala-elenco/sala-elenco.component";
import { ManageDeskComponent } from "./manage-desk/manage-desk.component";
import { DocumentsComponent } from "./documents/documents.component";
import { CommesseComponent } from "./gestione-commesse/gestione-commesse.component";
import { ClientsComponent } from "./clients/clients.component";
import { OffersComponent } from "./offers/offers.component";
import { StimeComponent } from "./stime/stime.component";
import { StatisticheComponent } from "./statistiche/statistiche.component";
import { ScadenzeFatturazioneComponent } from "./scadenze-fatturazione/scadenze-fatturazione.component";
import { TicketDaFatturareComponent } from "./ticket-da-fatturare/ticket-da-fatturare.component";
import { AnalisiTicketComponent } from "./analisi-ticket/analisi-ticket.component";
import { ClientService } from "./service/clients.service";
import { OfferService } from "./service/offers.service";
import { StimeService } from "./service/stime.service";
import { StatisticheService } from "./service/statistiche.service";
import { AnalisiTicketService } from "./service/analisi-ticket.service";
import { ScadenzeFatturazioneService } from "./service/scadenze.service";
import { TaskService } from "./service/task.service";
import { AnomalieUserSettingComponent } from "./anomalies-user-setting/anomalie-user-setting.component";
import { GestioneUfficioComponent } from "./gestione-ufficio/gestione-ufficio.component";
import { DetailAssenzaMalattiaComponent } from './detail-assenza-malattia/detail-assenza-malattia.component';
import { GestioneGruppiComponent } from './gestione-gruppi/gestione-gruppi.component';
import { GestioneGruppiService } from "./service/gestione-gruppi.service";

@NgModule({
	declarations: [
		CommesseComponent,
		ClientsComponent,
		OffersComponent,
		StimeComponent,
		StatisticheComponent,
		ScadenzeFatturazioneComponent,
		TicketDaFatturareComponent,
		AnalisiTicketComponent,
		AppComponent,
		CoreComponent,
		LoginComponent,
		ChangePasswordComponent,
		HomeComponent,
		CartellinoComponent,
		BusyComponent,
		AnomalieComponent,
		DailyPresenceComponent,
		PresenceDurationPipe,
		ActivityDurationPipe,
		SafeHtmlPipe,
		DaysHoursPipe,
		DailyActivityComponent,
		DetailPresenceComponent,
		PresencesComponent,
		ActivitiesComponent,
		StatisticsComponent,
		DetailActivityComponent,
		TaskSelectorComponent,
		ReportsComponent,
		TaskDetailComponent,
		UserAnomaliesComponent,
		AssenzeComponent,
		AssenzeProspectComponent,
		GlobalFilterComponent,
		DetailAssenzeComponent,
		AdministrationComponent,
		UsersComponent,
		UsersProspectComponent,
		ExtraworkUserComponent,
		CheckhrComponent,
		CheckhrDefsComponent,
		CheckhrUsersComponent,
		CheckhrUserComponent,
		UserOptionsComponent,
		EquipmentComponent,
		EquipmentDefsComponent,
		EquipmentUsersComponent,
		EquipmentUserComponent,
		HolidaysReportComponent,
		UserDataComponent,
		UserCalendarComponent,
		UfficioComponent,
		DetailSalaComponent,
		ElencoSalaComponent,
		ScrivanieComponent,
		DetailScrivaniaComponent,
		ManageDeskComponent,
		DocumentsComponent,
		AnomalieUserSettingComponent,
		GestioneUfficioComponent,
		DetailAssenzaMalattiaComponent,
		GestioneGruppiComponent
	],
	imports: [
		BrowserModule,
		NoopAnimationsModule,
		FormsModule,
		HttpModule,
		routing,
		CalendarModule,
		ChartModule,
		DropdownModule,
		TooltipModule,
		DialogModule,
		AutoCompleteModule,
		InputTextareaModule,
		FileUploadModule,
		InputTextModule,
		InputMaskModule,
		ListboxModule,
		CheckboxModule,
		GrowlModule,
		ConfirmDialogModule,
		MultiSelectModule,
		OverlayPanelModule,
	],
	providers: [AuthAccessProvider, MessageProvider, ConfirmationService, AuthenticationService, BusyProvider, ClientService, ClientsRequest, ClientsResponse,
		OfferService, OffersRequest, StimeService, StimeResponse, StatisticheService, OffersResponse, ScadenzaResponse, ScadenzeFatturazioneService, ScadenzaRequest, TaskService, GestioneGruppiService, AnalisiTicketService
	],

	bootstrap: [AppComponent],
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts